import { render, staticRenderFns } from "./gridFuncionalidade.vue?vue&type=template&id=45723a58&scoped=true&"
import script from "./gridFuncionalidade.vue?vue&type=script&lang=js&"
export * from "./gridFuncionalidade.vue?vue&type=script&lang=js&"
import style0 from "./gridFuncionalidade.vue?vue&type=style&index=0&id=45723a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45723a58",
  null
  
)

export default component.exports